module.exports = __webpack_public_path__ + "f79eb84c130e1da0cbd2b8a8ecb6f796.svg";